import { PlanStack } from '@zapier/design-system-revenue/src/types';
import { BillingInterval } from '@zapier/design-system-revenue/src/graphql-types';
import { planIds } from './planIds';

const commonProps = {
  __typename: 'PlanV2' as 'PlanV2',
  allowCompanies: false,
  description: 'Unleash the power of automation.',
  hasAutoReplay: false,
  hasPaths: false,
  hasMultiStepZaps: true,
  hasPremiumApps: true,
  hasTeams: false,
  hasMeteredBilling: false,
  tiers: [],
  isInPlanGroup: true,
  features: [
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Multi-step Zaps',
      tooltip:
        'Multi-Step Zaps let a single Trigger (e.g. new email lead) perform as many Actions (e.g. add to my CRM) as you want.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: '/apps?filter=premium',
      name: '3 Premium Apps',
      tooltip:
        'Premium apps are select apps that are exclusively available to users on a paid plans.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Filters',
      tooltip:
        'Filters tell your Zaps to run only if your data matches certain criteria.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Formatters',
      tooltip:
        'Formatters let you tweak numbers, dates, and text in over a dozen ways to get it in the format you need.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Custom Integrations',
      tooltip:
        'Build powerful, custom integrations that connect any app with Webhooks by Zapier.',
    },
  ],
  type: 'Starter',
  zaps: 20,
  zapsRunInterval: 15,
};

export const starterPlanStackMock: PlanStack = {
  __typename: 'PlanTaskGrouping',
  id: 'Starter',
  plans: [
    {
      ...commonProps,
      amount: 23988,
      interval: BillingInterval.year,
      id: planIds.STARTER_750_YEARLY,
      name: 'Starter (750 Tasks)',
      tasks: 750,
    },
    {
      ...commonProps,
      amount: 2499,
      interval: BillingInterval.month,
      id: planIds.STARTER_750_MONTHLY,
      name: 'Starter (750 Tasks)',
      tasks: 750,
    },
    {
      ...commonProps,
      amount: 46800,
      interval: BillingInterval.year,
      id: planIds.STARTER_1500_YEARLY,
      name: 'Starter (1,500 Tasks)',
      tasks: 1500,
    },
    {
      ...commonProps,
      amount: 4875,
      interval: BillingInterval.month,
      id: planIds.STARTER_1500_MONTHLY,
      name: 'Starter (1,500 Tasks)',
      tasks: 1500,
    },
  ],
  planType: 'Starter',
};
